import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { filter, Observable, take } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '@core/store';
import * as fromCustomerStore from '@appStore/customers';
import * as fromAccountStore from '@appStore/account';
import * as fromMeteringStore from '@appStore/metering-points';
import { Customer, InformationGroup, MeteringPoint } from '@model';
import { SubSink } from 'subsink';
import { UserType } from '@enums';

@Component({
    selector: 'app-carousel',
    templateUrl: './carousel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CarouselComponent implements OnInit {
  informationGroup$: Observable<InformationGroup>;
  informationLoaded$: Observable<boolean>;
  customers$: Observable<Customer[]>;
  customersLoaded$: Observable<boolean>;
  meteringPoints$: Observable<MeteringPoint[]>;
  meteringPointsLoaded$: Observable<boolean>;
  userType$: Observable<UserType>;

  private subs = new SubSink();

  constructor(
    private store: Store<fromStore.InformationState>,
    private accountStore: Store<fromAccountStore.State>,
    private meteringStore: Store<fromMeteringStore.State>,
    private customerStore: Store<fromCustomerStore.State>) {}

  ngOnInit() {
    this.customerStore
      .select(fromCustomerStore.getCustomersLoaded)
      .pipe(
        filter(x => !x),
        take(1)
      )
      .subscribe(x => {
        this.customerStore.dispatch(new fromCustomerStore.CustomersLoadData());
    });

    this.customers$ = this.customerStore.select(fromCustomerStore.getCustomers);
    this.customersLoaded$ = this.customerStore.select(fromCustomerStore.getCustomersLoaded);

    this.informationLoaded$ = this.store.select(fromStore.getInformationLoaded);
    this.informationGroup$ = this.store.select(fromStore.getCombinedInformationGroupData);

    this.userType$ = this.accountStore.select(fromAccountStore.getUserType);

    this.meteringPoints$ = this.meteringStore.select(fromMeteringStore.getMeteringPoints);
    this.meteringPointsLoaded$ = this.meteringStore.select(fromMeteringStore.getMeteringPointsLoaded);
  }
}
